import { TColorIndex } from '../../../types/redux';

function getColor(index: TColorIndex) {
  switch (index) {
    case 0:
      return 'red' as const;
    case 1:
      return 'blue' as const;
  }
}

export function getLegend(datasets: { data: number[]; label: string }[]) {
  return datasets.map((dataset, index) => {
    return {
      color: getColor(index as TColorIndex),
      label: dataset.label,
    };
  });
}
